import httpUtil from "@/utils/httpUtil";
import config from "@/config"

/** 获取证书类型 */
export function index_list(params,type) {
    return httpUtil.get(`${config.API_URL}/index/index`, params, type)
}

/** 配置 */
export function index_config(params,type) {
    return httpUtil.get(`${config.API_URL}/index/config`, params, type)
}
/** 查询个人证书*/
export function search_person(params,type) {
    return httpUtil.get(`${config.API_URL}/index/search_person`, params, type)
}

/** 查询企业证书 */
export function search_qiye(params,type) {
    return httpUtil.get(`${config.API_URL}/index/search_qiye`, params, type)
}

/** 查询企业荣誉 */
export function search_rongyu(params,type) {
    return httpUtil.get(`${config.API_URL}/index/search_rongyu`, params, type)
}

/** 查询企业会员 */
export function search_user(params,type) {
    return httpUtil.get(`${config.API_URL}/index/search_user`, params, type)
}











